export enum QuestionType {
    Amount = 'amount',
    Multiplechoice = 'multiplechoice',
    Text = 'text',
    MultilineText = 'multilinetext'
}